import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';


export function createTranslateLoader(http: HttpClient) {
  // TranslateHttpLoader v17 ya no recibe (http, prefix, suffix): loader inline
  return { getTranslation: (lang: string) => http.get('./assets/i18n/' + lang + '.json') } as any;
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      },
      isolate: false
    }),
  ],
  exports: [TranslateModule],
})
export class TranlationConfigModule {

  constructor(@Optional() @SkipSelf() parentModule?: TranlationConfigModule) {
    if (parentModule) {
      throw new Error(
        'TranlationConfigModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(): ModuleWithProviders<TranlationConfigModule> {
    return {
      ngModule: TranlationConfigModule,
      // providers: [ShoppingCartService, AccountService]
    }
  }
 }
